<template>
  <div>
    <PageAllow controller="ContainerCategories" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet v-show="!currentItemMode" class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="options.keyword"
                @text="CategorizeKeyword = $event"
                :label="$t('ContainerCategories.Keyword')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
              <!-- 新增分类 弹窗 -->
              <v-btn
                small
                color="primary"
                @click.stop="currentItemMode = 'new'"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("ContainerCategories.ObjectName")]) }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="container_categories"
            :options.sync="options"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.status="{ item }">
              <!-- 状态文字/颜色 -->
              <v-chip
                small
                label
                :color="item.status | stockContainerColor"
                :text-color="item.status | stockContainerTextColor"
              >
                {{ item.status | stockContainerText }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <!-- 查看 -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="secondary"
                    class="px-1 me-1"
                    @click.stop="
                      currentItemMode = 'view';
                      currentItem = item;
                    "
                    >fa-file-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [$t("ContainerCategories.title")])
                }}</span>
              </v-tooltip>
              <!-- 编辑 -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="px-1 me-1"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = item;
                    "
                    >fa-pencil-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.editInfo", [$t("ContainerCategories.title")])
                }}</span>
              </v-tooltip>
              <!-- 删除 -->
              <v-tooltip top v-if="item.deletable == 1">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="danger"
                    class="px-1 me-1"
                    @click.stop="
                      currentItem = item;
                      deleteDialog = true;
                    "
                    >fa-trash-alt
                  </v-icon>
                </template>
                <span>
                  {{ $t("CRUD.deleteInfo", [$t("ContainerCategories.title")]) }}
                </span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <!-- 删除 -->
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('ContainerCategories.ObjectName')"
      @confirm="
        deleteCategory();
        deleteDialog = false;
      "
    />
    <!-- 详情页 -->
    <DistrictsContainersDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      v-on:save="getContainerCategoryFromAPI()"
    />
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import DistrictsContainersDetail from "./plugins/Detail";
import ContainerCategories from "@/api/container_categories";
import DialogDelete from "@/components/plugins/DialogDelete";

const defaultOptions = {
  CategorizeKeyword: "",
  district_ids: [],
  status: [0, 1, -1],
};

export default {
  name: "stocksContainer",
  data: () => ({
    container_categories: [],
    paging: {},
    dialog: false,
    options: JSON.parse(
      sessionStorage.getItem("districtsContainers-options")
        ? sessionStorage.getItem("districtsContainers-options")
        : JSON.stringify(defaultOptions)
    ),
    CategorizeKeyword: "",
    currentItemMode: null,
    currentItem: null,
    stockDistrictsSelected: [],
    initialize: 0,
    serverErrors: [],
    deleteDialog: false,
  }),
  components: {
    Breadcrumbs,
    SearcherKeyword,
    PageAllow,
    DialogDelete,
    DistrictsContainersDetail,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.stocks"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.stockContainers"),
        disabled: false,
        href:
          "/stocks/stock-containers?stock_id=" +
          sessionStorage.getItem("stock_id"),
      },
      {
        text: i18n.t("Nav.containerCategories"),
        disabled: true,
        href: "/container-categories",
      },
    ],
    headers: () => [
      {
        text: i18n.t("ContainerCategories.Fields.container_categories_code"),
        align: "start",
        sortable: false,
        value: "category_code",
      },
      {
        text: i18n.t("ContainerCategories.Fields.container_categories_name"),
        align: "start",
        sortable: false,
        value: "category_name",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    ...mapState(["loading"]),
  },
  mounted() {
    this.$commonUtils
      .loadOptions("Container-categories", ["stockDistrictsSelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stockDistrictsSelected":
                this.stockDistrictsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options, {
        keyword: this.CategorizeKeyword,
      });
    },
    resetSearch() {
      this.stockDistrictsSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    getContainerCategoryFromAPI() {
      ContainerCategories.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.container_categories = response.data.container_categories;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    // 弹窗 确认删除
    deleteCategory() {
      if (this.currentItem) {
        ContainerCategories.del(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getContainerCategoryFromAPI(); // 删除成功刷新数据
            }
          }.bind(this)
        );
      }
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getContainerCategoryFromAPI();
        sessionStorage.setItem(
          "districtsContainers-options",
          JSON.stringify(this.options)
        );
      },
    },
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
        }
      },
    },
    stockDistrictsSelected: {
      handler() {
        this.options.district_ids = this.stockDistrictsSelected
          ? this.stockDistrictsSelected.map((stockDistrict) => {
              return stockDistrict.id;
            })
          : "";
        sessionStorage.setItem(
          "stocks-stockDistrictsSelected",
          JSON.stringify(this.stockDistrictsSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>